import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from "@angular/material/snack-bar";
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-htmlsnackbar-content',
    templateUrl: './htmlsnackbar-content.component.html',
    styleUrls: ['./htmlsnackbar-content.component.scss'],
    imports: [MaterialModule]
})
export class HTMLSnackbarContentComponent {

  public data = inject(MAT_SNACK_BAR_DATA);
  public snackBar = inject(MatSnackBar);

}
